module.exports = __webpack_public_path__ + "static/media/clock-small.bc2ba08e.gif";